import { type MCPServerInfo } from '../../types';

const SpaceliftServer: MCPServerInfo = {
  serverId: 'SPACELIFT',
  name: 'Spacelift',
  slug: 'spacelift',
  description:
    'Spacelift MCP Server - Infrastructure as Code management platform with stack management, module registry, and GraphQL API access',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/spacelift-io/spacectl',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/spacelift-io/spacectl'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['spaceliftUrl', 'spaceliftApiKeyId', 'spaceliftApiKeySecret'],
    properties: {
      spaceliftUrl: {
        type: 'string',
        description: 'Spacelift URL (e.g., https://mycorp.app.spacelift.io)',
        sensitive: false
      },
      spaceliftApiKeyId: {
        type: 'string',
        description: 'Spacelift API Key ID',
        sensitive: true
      },
      spaceliftApiKeySecret: {
        type: 'string',
        description: 'Spacelift API Key Secret',
        sensitive: true
      }
    }
  }
};

export default SpaceliftServer;
